import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpXsrfTokenExtractor } from "@angular/common/http";
import { HttpRequest } from "@angular/common/http";
import { catchError, switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SpinnerService } from '../services/spinner.service';
import { SnackbarMessageComponent } from '../components/snackbar/snackbar-message/snackbar-message.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private tokenExtractor: HttpXsrfTokenExtractor,
    private spinnerService: SpinnerService,
    private router: Router,
    private snackbar: MatSnackBar,
    private cookieService: CookieService,
    private authenticationService: AuthenticationService) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const CSRFHeaderName = 'X-XSRF-TOKEN';
    let csrfToken = this.tokenExtractor.getToken() as string;
    if (csrfToken !== null && !req.headers.has(CSRFHeaderName)) {
      req = req.clone({ headers: req.headers.set(CSRFHeaderName, csrfToken) });
    }

    return next.handle(req)
      .pipe(
        catchError(
          (errorResponse, caught) => {
            if (errorResponse instanceof HttpErrorResponse) {

              if (errorResponse.status) {
                if (errorResponse.status === 401) {
                  if (req.url !== '/api/oidc/refresh') {
                    return this.handle401Error(req, next);
                  }
                }
                else if (errorResponse.status === 500) {
                  this.spinnerService.hide();
                  this.showMessage(errorResponse);
                }
                else if (errorResponse.status === 302) {

                  this.spinnerService.hide();
                  this.showMessage(errorResponse);

                  if (errorResponse.error.RedirectUrl) {
                    this.router.navigateByUrl(errorResponse.error.RedirectUrl);
                  }

                }
              }

              return throwError(() => errorResponse);

            }
            return caught;
          })
      );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {

    return this.authenticationService.refreshToken()
      .pipe(
        switchMap(
          () => {
            this.authenticationService.setRefreshTokenToSessionStorage();
            return next.handle(request)
          }),
        catchError(
          (errorResponse, caught) => {
            if (errorResponse.status === 401) {
              this.authenticationService.login(this.router.url);
            }
            else {
              this.showMessage(errorResponse);
            }
            return throwError(() => errorResponse);
          }
        )

      );
  }

  private showMessage(errorResponse: HttpErrorResponse): void {
    if (errorResponse.error.title) {
      this.snackbar.openFromComponent(SnackbarMessageComponent,
        {
          data: {
            message: errorResponse.error.title,
            type: 'error'
          }
        });
    }
  }
}